import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import reportWebVitals from './reportWebVitals'
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { AuthProvider } from './components/AuthContext';
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthProvider>
    <App />
      {/* Other components */}
    </AuthProvider>
     
   
  </React.StrictMode>
  
);

// serviceWorkerRegistration.register();
